export default "__VITE_PUBLIC_ASSET__e111ac6a__"